import { connect } from 'react-redux';
import { compose, applySpec, equals, pipe } from 'ramda';
import { show as showModal } from 'redux-modal';

import { DELETE_REPORT } from 'constants/modals';
import DeviceTransmissionReport from 'components/DeviceTransmissionReport';
import {
  getReportItemAttachmentLoading,
  getReportItemSentOn,
  getReportItemAttachmentUrl,
  getReportItemReadByPatient,
  getReportItemOpenedDateTime,
  getTransmissionTypeValue,
  getTransmissionAdditionalDocs,
  getReportItemStatus,
  getReportItemDeviceClinicNameValue,
  getUnscheduledVisitReason,
} from 'store/selectors/reports/singleItems';
import { REGISTERED } from 'constants/observationStatuses';
import { isResearcher, isTechnician } from 'store/selectors/user';

import { getPatientDeviceName } from 'store/selectors/patientsData';
import { reportsDownloadPdf } from 'store/actionCreators/reports/singleItems';

const mapStateToProps = (state, { patientId, reportId }) =>
  applySpec({
    deviceClinicEmail: getReportItemDeviceClinicNameValue(reportId),
    attachmentUrl: getReportItemAttachmentUrl(reportId),
    attachmentLoading: getReportItemAttachmentLoading(reportId),
    deviceName: getPatientDeviceName(patientId),
    sentOn: getReportItemSentOn(reportId),
    isRegisteredReport: pipe(
      getReportItemStatus(reportId),
      equals(REGISTERED),
    ),
    isTechnician,
    markedReadByPatient: getReportItemReadByPatient(reportId),
    markedOpenByPatient: getReportItemOpenedDateTime(reportId),
    isResearcher,
    transmissionType: getTransmissionTypeValue(reportId),
    unscheduledVisitReason: getUnscheduledVisitReason(reportId),
    additionalDocuments: getTransmissionAdditionalDocs(reportId),
    patientId: () => patientId,
    observationId: () => reportId,
  })(state);

const mapDispatchToProps = (dispatch, { reportId }) => ({
  handleDownloadReport: ({ attachmentUrl, patientId, deviceName, sentOn }) => () =>
    dispatch(
      reportsDownloadPdf({
        url: attachmentUrl,
        fileName: `RPM-CIED-${patientId}-${deviceName}-${sentOn.substring(0, 10)}`,
      }),
    ),
  handleDownloadDocument: id => () =>
    dispatch(
      reportsDownloadPdf({
        url: `DocumentReference/${id}`,
      }),
    ),
  handleRemoveReportClick: () => dispatch(showModal(DELETE_REPORT, { reportId })),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DeviceTransmissionReport);
